import React, { useRef, useState } from 'react';
import GQPopup from '../components/GQPopups/GQPopup';
const DiscoverFilterDeleteModal = (props) => {
    // removeCustomFilterFromListAction saves the config, so hold the dialog open until
    // that lands instead of closing over a list that has not been stored yet. Cancel
    // stays live so a stalled save cannot trap the user; once they dismiss it, the
    // request finishes quietly rather than closing whatever dialog is open by then.
    const [deleting, setDeleting] = useState(false);
    const dismissed = useRef(false);

    const dismiss = () => {
        dismissed.current = true;
        props.closeModal();
    }

    const removeCustomFilterFromList = async (filter, fieldConfig, idx) => {
        if (deleting) {
            return;
        }
        setDeleting(true);
        try {
            await props.removeCustomFilterFromListAction(filter, fieldConfig, idx);
        } catch (err) {
            console.log('delete custom filter failed', err);
        }
        if (dismissed.current) {
            return;
        }
        setDeleting(false);
        props.closeModal();
    }

    return (
        <GQPopup
            show={props.showModal}
            close={dismiss}
            innerHtml={
                <div style={{ width: '400px' }}>
                    <h4 style={{ marginBottom: '12px' }}>Delete</h4>
                    <p style={{ marginBottom: '16px' }}>Are you sure you want to delete this?</p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <button className='small-button cancelButtonClass' onClick={dismiss}>Cancel</button>
                        <button
                            className='small-button submitButtonClass'
                            disabled={deleting}
                            onClick={() => { removeCustomFilterFromList(props.filter, props.fieldConfig, props.deleteIdx); }}
                        >
                            {deleting ? 'Deleting...' : 'Delete'}
                        </button>
                    </div>
                </div>
            }
        />
    );
}
export default DiscoverFilterDeleteModal;
